import request from "@/utils/request";
import {IUserModel} from "./types";


export const getWarehouseInChargeTemplate = () =>
    request({
        url: `/warehousing-charge-calculation-template`,
        method: "get"
    });

export const createWarehouseInChargeTemplate = (data: any) =>
    request({
    url: "/warehousing-charge-calculation-template",
    method: "post",
    data
});

